import { useState, useEffect } from 'react';

function useLocalStorage(key, initialValue) {
   // Get from local storage then parse stored json or return initialValue
   const [storedValue, setStoredValue] = useState(() => {
      try {
         const item = window.localStorage.getItem(key);
         return item ? JSON.parse(item) : initialValue;
      } catch (error) {
         console.log(error);
         return initialValue;
      }
   });

   // Return a wrapped version of useState's setter function that persists the new value to localStorage
   const setValue = (value) => {
      try {
         // Allow value to be a function so we have the same API as useState
         const valueToStore = value instanceof Function ? value(storedValue) : value;
         setStoredValue(valueToStore);
         window.localStorage.setItem(key, JSON.stringify(valueToStore));
      } catch (error) {
         console.log(error);
      }
   };

   return [storedValue, setValue];
}

export default useLocalStorage;